
import { defineComponent } from 'vue';
import { auth } from '@/firebase/init';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { FirebaseError } from 'firebase/app';
import { authGeneralErrorHandle } from '@/firebase/authErrorHandle';
import { forceAllWorkplacesStateSingletonReset } from '@/firebase/database';
export default defineComponent({
  name: 'SignUpPage',
  data() {
    return {
      username: '' as string,
      email: '' as string,
      password: '' as string,
      passwordConfirm: '' as string,
      errorVisible: false as boolean,
      errorText: 'error' as string
    };
  },
  methods: {
    signUp(
      username: string,
      email: string,
      password: string,
      passwordConfirm: String
    ) {
      if (!validateEmail(email)) {
        this.errorText = 'Please enter a valid email address!';
        this.errorVisible = true;
      } else if (password !== passwordConfirm) {
        this.errorText = 'Passwords do not match!';
        this.errorVisible = true;
      } else {
        (async () => {
          try {
            forceAllWorkplacesStateSingletonReset();
            const userObj = await createUserWithEmailAndPassword(
              auth,
              email,
              password
            );
            updateProfile(userObj.user, {
              displayName: username
            });
            this.$router.push('/projectManager');
          } catch (e: FirebaseError | any) {
            if (e instanceof FirebaseError) {
              const errMsg = authGeneralErrorHandle(e).msg;
              this.errorText = errMsg;
              this.errorVisible = true;
            }
          }
        })();
      }
    }
  }
});

function validateEmail(email: string) {
  let validRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (email.match(validRegex)) return true;
  return false;
}
